import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react';

import { useModalManagerContext } from '../../components/ModalManager/ModalManagerContext';

const UpdateAddressPromptModal: React.FC = () => {
  const { t } = useTranslation();
  const {
    goToFirstStep,
    jumpSteps,
    loadNextFlowStep,
  } = useModalManagerContext();

  return (
    <>
      <ModalHeader>{t('cancelModal.address.modalPromptTitle')}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Box>
          <Text variant="strong">{t('cancelModal.address.promptTitle')}</Text>
          <Text>{t('cancelModal.address.promptSubtitle')}</Text>
          <Button onClick={loadNextFlowStep} variant="outlinedBig">
            {t('cancelModal.address.promptUpdateAddress')}
          </Button>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Button mr="4" onClick={goToFirstStep} variant="outlinedBig">
          {t('cancelModal.back')}
        </Button>
        <Button onClick={() => jumpSteps(2)} variant="blackBig">
          {t('cancelModal.continueWithCancellation')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default UpdateAddressPromptModal;
